/* src/app/start/start.component.scss */
td {
  text-align: left;
  min-width: 50px;
}
li {
  list-style-type: none;
}
table {
  border-collapse: separate;
  border-spacing: 0.5em;
}
tr:hover {
  cursor: pointer;
}
/*# sourceMappingURL=start.component.css.map */
